import { useState } from "react";


export const usePostCsvExcelAccountsStates = () => {
  const [csvExcelAccountId, setCsvExcelAccountId] = useState<string>("");

  return {
    csvExcelAccountId,
    setCsvExcelAccountId,
  };
};
